import { render, staticRenderFns } from "./ShopEditor.vue?vue&type=template&id=4937a86f&scoped=true"
import script from "./ShopEditor.vue?vue&type=script&lang=ts"
export * from "./ShopEditor.vue?vue&type=script&lang=ts"
import style0 from "./ShopEditor.vue?vue&type=style&index=0&id=4937a86f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937a86f",
  null
  
)

export default component.exports